import { i18n } from '@/plugins/i18n'
import { uploadService } from '@/services/api'

export default class UploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                const loader = this.loader;

                let data = {
                    file: file
                }

                uploadService.doUpload(data, 'campaigns', (percent) => {
                    loader.uploadTotal = percent;
                    loader.uploaded = percent === 100 ? true : false;
                }).then((response) => {
                    resolve({
                        default: response.data.data.url
                    })
                }).catch(error => {
                    reject( error && error.response && error.response.data ? i18n.t(`tags.${error.response.data.tag}`) : i18n.t('tags.undefined') );
                })
            }));
    }
}